import { createClient } from '@supabase/supabase-js'

// Project ID: dyilrqfvtizuplwxozga
const SUPABASE_URL = 'https://dyilrqfvtizuplwxozga.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR5aWxycWZ2dGl6dXBsd3hvemdhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY1MTEwODEsImV4cCI6MjEwMjA4NzA4MX0.gIBLjCUu2gQJ-JcLB1YaCdez9izaPt7UhCeRB_EsnKk'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})